import React, { useEffect, useState } from "react";
import { Translate } from "react-localize-redux";
import { useLocation } from "react-router-dom";
import { LinkedIn } from "react-linkedin-login-oauth2";
import translations from "../../translations/verify.json";
import "../../styles/components/linkedinSharePopUpNew.scss";
import {
	getLinkedInUserIdProxy,
	postLinkedinArticle,
	getLinkedInAccessToken,
} from "../../services/verifiedBackendService/linkedin";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import BaseButton from "wallet-elementkit/dist/elementKit/baseButton/BaseButton";

import { storeItem, getItem, removeItem } from "../../backend/StorageUtils";
import { getPostLinkFromShareId } from "../../backend/LinkedinUtils";
import { EventsBackend } from "wallet-elementkit/dist/services";

const LinkedinSharePopUpNew = (props) => {
	props.addTranslation(translations);
	const search = useLocation().search;
	const [shareLoading, setShareLoading] = useState(false);
	const [addLinkedinLoading, setAddLinkedinLoading] = useState(false);
	const [isRedirected, setIsRedirected] = useState(false);
	const [postTitle, setPostTitle] = useState("");
	const [defaultPostTitle, setDefaultPostTitle] = useState("");
	const [addToProfile, setAddToProfile] = useState(
		!props.disableAddToLinkedin ?? true
	);
	const [shareToFeed, setShareToFeed] = useState(true);
	const [shareSuccessful, setShareSuccessful] = useState(true);
	const [error, setError] = useState(false);
	const [fromVerified, setFromVerified] = useState(false);
	const [shareId, setShareId] = useState(undefined);
	useEffect(() => {
		setFromVerified(search.includes("code"));
		const skillTags =
			(props.skills &&
				props.skills.reduce((tags, skill) => {
					return (tags += `#${skill.title
						.toLocaleLowerCase()
						.replace(/\s+/g, "")} `);
				}, "")) ||
			"";

		const defaultPostTitle = props.isCollection
			? `Check out my verified collection issued by ${props.issued_by} via Sertifier!\n#sertifier #digitalbadge #digitalcertificate #digitalcredentials ${skillTags}`
			: props.shareText
			? props.shareText
			: `Check out my ${props.certTitle} digital ${
					props.certificate_url && props.badge_url
						? "certificate/badge"
						: props.certificate_url
						? "certificate"
						: "badge"
			  } issued by ${
					props.issued_by
			  } via Sertifier!\n#sertifier #digitalbadge #digitalcertificate #digitalcredentials ${skillTags}`;

		setPostTitle(defaultPostTitle);
		setDefaultPostTitle(defaultPostTitle);

		const shareOptions = getItem("linkedinShare");
		if (shareOptions) {
			const title = shareOptions.postTitle;
			setIsRedirected(true);
			setPostTitle(title);
			setAddToProfile(shareOptions.addToProfile);
			setShareToFeed(shareOptions.shareToFeed);
		}

		if (props.isCollection) setAddToProfile(false);
	}, []);

	useEffect(() => {
		if (fromVerified && props.linkedinAuthCode) {
			setShareLoading(true);
			setAddLinkedinLoading(true);
			handleLinkedinShare(props.linkedinAuthCode);
		}
	}, [fromVerified, props.linkedinAuthCode]);

	useEffect(() => {
		if (shareToFeed || addToProfile) setError(false);
	}, [shareToFeed, addToProfile]);

	useEffect(() => {
		if (shareLoading || addLinkedinLoading) setIsRedirected(true);
	}, [shareLoading, addLinkedinLoading]);

	useEffect(() => {
		if (props.tokenCode && props.userId && shareToFeed && !props.isCollection) {
			handleSubmit();
		}
	}, [props.tokenCode, props.userId, shareToFeed, props.isCollection]);

	const forceOpenFeed = () => {
		const a = document.createElement("a");
		a.setAttribute("href", "https://www.linkedin.com/feed/");
		a.setAttribute("target", "_blank");
		a.click();
	};

	const forceOpenPost = () => {
		const a = document.createElement("a");
		a.setAttribute("href", getPostLinkFromShareId(shareId));
		a.setAttribute("target", "_blank");
		a.click();
	};

	const handleClick = async (sharingFor, linkedinShareData) => {
		if (props.isCollection) return;
		EventsBackend.logShareEventAnon(
			props.credential_no,
			sharingFor,
			props.organization_id,
			linkedinShareData
		);
	};

	const handleLinkedinShare = async (code) => {
		await getLinkedInAccessToken(code).then(async (tokenCode) => {
			props.setLinkedinToken(tokenCode);
			await getLinkedInUserIdProxy(tokenCode).then(async (userId) => {
				props.setLinkedinUserId(userId);
			});
		});
	};

	const shareOnLinkedin = async () => {
		var resp = await postLinkedinArticle(
			props.tokenCode,
			props.userId,
			props.articleUrl,
			props.certTitle ?? "Sertifier Credential",
			postTitle,
			props.credential_no
		);
		setShareLoading(false);
		setPostTitle(defaultPostTitle);
		props.setLinkedinToken("");
		if (resp.shareId) {
			setShareId(resp.shareId);
			setShareSuccessful(true);
			handleClick("linkedin", {
				shareId: resp.shareId,
				credential_no: props.credential_no,
				postTitle: postTitle,
			});
			if (!addToProfile) {
				var win = window.open(getPostLinkFromShareId(resp.shareId));
				if (win == null) {
					forceOpenPost();
				} else {
					win.focus();
				}
			}
		} else {
			setShareId(undefined);
			setShareSuccessful(false);
		}
	};

	const handleSubmit = async () => {
		try {
			if (!addLinkedinLoading) setAddLinkedinLoading(true);
			if (!shareLoading) setShareLoading(true);

			if (!shareToFeed && !addToProfile) {
				setError(true);
				return;
			}
			if (shareToFeed) {
				await shareOnLinkedin();
				if (addToProfile) {
					props.addLinkedin();
					setAddLinkedinLoading(false);
				}
			} else if (!shareToFeed && addToProfile) {
				props.addLinkedin();
				props.handleClose();
			}

			removeItem("linkedinShare");
		} catch (e) {
			removeItem("linkedinShare");
			setShareLoading(false);
			setAddLinkedinLoading(false);
			setShareSuccessful(false);
			setShareId(undefined);
			setError(true);
		}
	};

	const handleLinkedinLogin = () => {
		if (!props.isCollection && shareToFeed) {
			storeItem("linkedinShare", {
				shareToFeed: shareToFeed,
				addToProfile: addToProfile,
				postTitle: postTitle,
			});
		} else {
			handleSubmit();
		}
	};

	return (
		<Modal id="share-dialog" className="jc-c" show={props.dialogOpen} centered>
			<Modal.Title className="dialog-title">
				<span className="s5 boldish">
					{props.isCollection ? (
						<Translate id="shareCollectionOnLinkedin" />
					) : (
						<Translate id="shareCredentialOnLinkedin" />
					)}
				</span>
			</Modal.Title>
			{isRedirected ? (
				<Modal.Body>
					{addToProfile && (
						<div className="flex-row ai-fs share-step">
							{addLinkedinLoading ? (
								<Spinner className="spinner-border" animation="border" />
							) : props.redirectSuccessful ? (
								<img
									alt="Verified Check Icon"
									className="icon"
									src={require("../../assets/common/checkmark.svg").default}
								/>
							) : (
								<img
									alt="Verified Error Icon"
									className="icon"
									src={require("../../assets/common/error.svg").default}
								/>
							)}

							<div className="flex-column ai-fs">
								<p className="s6 boldish step-title">
									<Translate id="addToProfile" />
								</p>
								<p className="s6">
									<Translate id="notRedirected" />{" "}
									<span onClick={() => props.addLinkedin?.()}>
										<Translate id="clickHere" />.
									</span>
								</p>
							</div>
						</div>
					)}
					{shareToFeed && (
						<div className="flex-row ai-fs share-step">
							{shareLoading ? (
								<Spinner className="spinner-border" animation="border" />
							) : shareSuccessful ? (
								<img
									alt="Verified Check Icon"
									className="icon"
									src={require("../../assets/common/checkmark.svg").default}
								/>
							) : (
								<img
									alt="Verified Error Icon"
									className="icon"
									src={require("../../assets/common/error.svg").default}
								/>
							)}
							<div className="flex-column ai-fs">
								<p className="s6 boldish step-title">
									<Translate id="shareToFeed" />
								</p>
								{shareSuccessful ? (
									<p className="s6">
										<Translate id="shareSuccessful" />{" "}
										{shareId && (
											<span onClick={() => forceOpenPost()}>
												<Translate id="seePost" />.
											</span>
										)}
									</p>
								) : (
									<p className="s6">
										<Translate id="shareFailed" />
									</p>
								)}
							</div>
						</div>
					)}
				</Modal.Body>
			) : (
				<Modal.Body>
					{!props.isCollection && !props.disableAddToLinkedin && (
						<Form.Group controlId="checkbox-group">
							<Form.Label className="s6-5 medium">
								{props.translate("shareOptions")}
							</Form.Label>
							<Form.Check
								type="checkbox"
								id="checkbox-1"
								className={error ? "error" : ""}
								label={props.translate("addToProfile")}
								checked={addToProfile}
								onChange={(e) => setAddToProfile(e.target.checked)}
							/>

							<Form.Check
								type="checkbox"
								id="checkbox-2"
								className={error ? "error" : ""}
								label={props.translate("shareToFeed")}
								checked={shareToFeed}
								onChange={(e) => setShareToFeed(e.target.checked)}
							/>
						</Form.Group>
					)}
					<Form.Group controlId="textarea">
						<Form.Label className="s6-5 medium">
							{props.translate("enterYourPost")}
						</Form.Label>
						<Form.Control
							as="textarea"
							placeholder={props.translate("enterYourPost")}
							onChange={(e) => setPostTitle(e.target.value)}
							value={postTitle}
							style={{ height: "150px" }}
						/>
					</Form.Group>
				</Modal.Body>
			)}
			{isRedirected ? (
				<Modal.Footer>
					<BaseButton
						type="secondary"
						size="small"
						loading={false}
						width={80}
						onClickAction={() => props.handleClose()}
					>
						<Translate id="gotIt" />
					</BaseButton>
				</Modal.Footer>
			) : (
				<Modal.Footer>
					<BaseButton
						type="secondary"
						size="small"
						loading={false}
						width={80}
						onClickAction={() => props.handleClose()}
					>
						<Translate id="cancel" />
					</BaseButton>
					<LinkedIn
						clientId="775jdov7xhw33h"
						redirectUri={`https://verified.sertifier.com/en/linkedinBounce?redirect_to=${
							window.location.href.toString().split("?")[0]
						}`}
						onSuccess={async (code) => handleLinkedinShare(code)}
						scope="r_emailaddress r_liteprofile w_member_social"
						closePopupMessage="Close Pop Up"
						onError={(error) => {
							console.log(error);
						}}
					>
						{({ linkedInLogin }) => (
							<BaseButton
								type="primary"
								size="small"
								loading={false}
								width={150}
								disabled={!shareToFeed && !addToProfile}
								onClickAction={() => {
									!props.isCollection && shareToFeed
										? linkedInLogin()
										: handleSubmit();
								}}
								styles={{
									width: "fit-content",
									minWidth: "150px",
								}}
							>
								<Translate id="shareOnLinkedin" />
							</BaseButton>
						)}
					</LinkedIn>
				</Modal.Footer>
			)}
		</Modal>
	);
};

export default LinkedinSharePopUpNew;
